// extracted by mini-css-extract-plugin
module.exports = {"placementWrapper":"addPlacement_placementWrapper__2xkAi","placementTable":"addPlacement_placementTable__33DDn","placementDetails":"addPlacement_placementDetails__2aaCa"};